<div class="tabbed-block">
  <ul class="tabs">
    <li *ngFor="let tab of tabs" [ngClass]="{active: tab.id === selected}">
      <a (click)="onUpdateSelection(tab);"><i *ngIf="tab.iconClass" [ngClass]="tab.iconClass">&nbsp;</i>{{tab.name}}</a>
    </li>
  </ul>
  <ng-content class="active"></ng-content>
</div>
